
import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { persistor } from '../redux/store';

const LogoutPage = () => {
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(true);

  useEffect(() => {
    const performLogout = async () => {
      try {
        setIsLoggingOut(true);
        
        // Step 1: Set localStorage flag to trigger logout in other tabs
      
        
        // Step 2: Clear localStorage and cookies
        localStorage.clear();
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i];
          const eqPos = cookie.indexOf('=');
          const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
          // Clear cookies for current domain
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${window.location.hostname}; secure`;
          // Clear cookies for root domain
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${window.location.hostname}; secure`;
          // Clear cookies for embedded iframes
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${window.location.hostname
            .split('.')
            .slice(-2)
            .join('.')}; secure`;
          // Clear cookies without domain restriction
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure`;
        }

        // Step 3: Try to sign out from Amplify (may fail if already logged out)
        try {
          await Auth.signOut();
        } catch (error) {
          console.log('Auth.signOut failed (user may already be logged out):', error);
        }

        // Step 4: Clear remaining localStorage items
        localStorage.removeItem('emailID');
        localStorage.removeItem('mobileNo');

        // Step 5: Purge Redux store LAST - this handles all state cleanup and navigation
        await persistor.purge();
  localStorage.setItem('logoutTrigger', Date.now().toString());
        console.log('Set logout trigger in localStorage');
        // Step 6: Clear logout trigger after everything is done
        localStorage.removeItem('logoutTrigger');

        // Step 7: Logout cleanup completed
        console.log('Logout cleanup completed, Redux purge will handle redirect to login...');
        
        // Fallback: If Redux doesn't redirect automatically, do it manually
       

      } catch (error) {
        console.error('Logout error:', error);
        // Redux purge will handle redirect to login even on error
      } finally {
        setIsLoggingOut(false);
      }
    };

    performLogout();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: 'background.default',
      }}
    >
      <CircularProgress size={60} sx={{ mb: 2 }} />
      <Typography variant="h6" color="text.secondary">
        Logging out...
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        Please wait while we sign you out
      </Typography>
    </Box>
  );
};

export default LogoutPage;
